import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1345.18 -4154)">
      <path
        d="M295.57.75a15,15,0,1,1-15,15,15,15,0,0,1,15-15"
        transform="translate(-1625 4154)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M310.33,13.148A14.986,14.986,0,0,0,295.57.751v15L285.932,4.263a15.032,15.032,0,1,0,24.4,8.885"
        transform="translate(-1625 4154)"
        fill={color}
      />
    </g>
  </svg>
);
